import React from 'react';
import styled from 'styled-components';
import { ProjectContainer, ProjectTitle, ProjectInfo } from './styles';
import { useLanguage } from '../../contexts/LanguageContext';

const ProjectDescription = styled.div`
  margin-bottom: 30px;
  line-height: 24px;
`;

const ProjectWrapper = styled.div`
  margin-bottom: 40px;
  
  h4 {
    font-size: 20px;
    color: #333;
    margin: 0 0 20px 0;
    font-weight: 600;
  }
  
  h5 {
    font-size: 16px;
    color: #333;
    margin: 20px 0 10px 0;
    font-weight: 600;
  }
  
  p {
    line-height: 24px;
    margin-bottom: 15px;
    
    a {
      color: #F34452;
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }
  
  img {
    width: 100%;
    max-width: 600px;
    height: auto;
    margin-bottom: 20px;
    border: 1px solid #eee;
    
    &.img-centered {
      display: block;
      margin: 0 auto 20px auto;
    }
    
    &.team-image {
      max-width: 500px;
    }
  }
  
  iframe {
    width: 100%;
    max-width: 500px;
    height: 281px;
    border: 1px solid #eee;
    margin: 20px 0;
    
    &:first-of-type {
      max-width: 420px;
      height: 315px;
    }
  }
  
  ul.list-inline {
    list-style: none;
    padding: 0;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    
    li {
      b {
        color: #333;
      }
    }
  }
  
  .closeBtn {
    text-align: center;
    margin-top: 30px;
    
    button {
      background: #007bff;
      color: #FFF;
      border: none;
      padding: 12px 25px;
      border-radius: 3px;
      cursor: pointer;
      font-weight: 600;
      transition: all 0.3s;
      
      &:hover {
        background: #0056b3;
      }
      
      i {
        margin-right: 8px;
      }
    }
  }
`;

interface ProjectHciProps {
}

const ProjectHci: React.FC<ProjectHciProps> = () => {
  const { t } = useLanguage();
  
  return (
    <ProjectContainer>
      <ProjectTitle>
        <h2>{t('hci.title')}</h2>
        <p className="tags">{t('hci.role')}</p>
      </ProjectTitle>
      
      <ProjectDescription>
        {t('hci.description')}
      </ProjectDescription>
      
      <ProjectInfo>
        <p><b>{t('hci.roleLabel')}</b> {t('hci.myRole')}</p>
        <p><b>{t('hci.skillsLabel')}</b> {t('hci.skillsUtilized')}</p>
      </ProjectInfo>

      <img loading="lazy" decoding="async" className="img-responsive img-centered" src="/images/projects/hci01-min.webp" alt=""/>

      <ProjectWrapper>
        <h4>{t('hci.problems')}</h4>
        <p>
          {t('hci.problemsDesc')}
        </p>
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t('hci.solutions')}</h4>
        <p>
          {t('hci.solutionsDesc')}
        </p>
        <h4>{t('hci.paperPrototypes')}</h4>
        <p>{t('hci.paperPrototypesDesc')}</p>
        <p>{t('hci.lowQualityPrototypes')} <a href="https://invis.io/KJ504APR2" target="_blank" rel="noopener noreferrer">https://invis.io/KJ504APR2</a></p>
        <h4>{t('hci.lowQualityDemo')}</h4>
        <iframe 
          src="https://www.youtube.com/embed/ODh2gFGO0VA" 
          frameBorder="0" 
          allowFullScreen
          title="Low quality prototypes demo"
        ></iframe>
        <h4>{t('hci.highQualityPrototypes')}</h4>
        <p>{t('hci.highQualityDesc')}</p>
        
        <h5>{t('hci.highQualityPrototypes2')}</h5>
        <iframe 
          src="https://player.vimeo.com/video/162628656" 
          frameBorder="0" 
          allowFullScreen
          title="High quality prototypes"
        ></iframe>
        <h5>{t('hci.iterativePrototypes')}</h5>
        <p>{t('hci.highQualityPrototypes3')} <a href="http://51qjzm.axshare.com/#c=2" target="_blank" rel="noopener noreferrer">http://51qjzm.axshare.com/#c=2</a></p>
        <iframe 
          src="https://player.vimeo.com/video/162629322" 
          frameBorder="0" 
          allowFullScreen
          title="Iterative Prototypes"
        ></iframe>
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t('hci.ourPoster')}</h4>
        <img loading="lazy" decoding="async" className="img-responsive img-centered" src="/images/projects/hci2-min.webp" alt="poster"/>
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t('hci.ourTeam')}</h4>
        <img loading="lazy" decoding="async" className="img-responsive img-centered team-image" src="/images/portfolio/hciteam-min.webp" alt="hciteam"/>
      </ProjectWrapper>

      <ProjectWrapper>
        <ul className="list-inline">
          <li><b>{t('hci.dateLabel')}</b> {t('hci.dateRange')}</li>
          <li><b>{t('hci.teamMembersLabel')}</b> {t('hci.teamMembers')}</li>
        </ul>
      </ProjectWrapper>
    </ProjectContainer>
  );
};

export default ProjectHci;